import React from 'react';
import { format } from 'date-fns';

export default ({ startedAt }) => (
    <li className="timeline__item">
        <div className="event event--flow">Started at {format(startedAt, 'h:mm A')}</div>
    </li>
);
